import React, { Component } from 'react'
import {
  getProjects,
} from '../../store/ducks/humanResources'
import { getOikosId, getProductsByRespId, getReceitasFromOikos, getPfProjectsByPfId } from '../../utils/fc/index'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Link, Redirect } from 'react-router-dom'
import {
  Container, Row, Col, Card, CardBody, Media, Button, Modal, ModalHeader, ModalBody, ModalFooter,
  FormGroup, Label, Input, Table,
  Spinner,
} from 'reactstrap'
import moment from 'moment'
import Select from '../../components/Template/Input/Select'
import Breadcrumbs from '../../components/Common/Breadcrumb'

class EPApprovement extends Component {
  constructor(props) {
    super(props)
    this.state = {
      receitas: null,
    }
  }

  componentDidMount() {
    this.preloading()
  }

  preloading = async () => {
    if (!this.props.userOikosId) return;

    const [allRec, myProjects] = await Promise.all([
      getReceitasFromOikos(),
      getPfProjectsByPfId(this.props.userOikosId)
    ]);
    const myProjectNames = myProjects.map(p => p.proj_nome);

    const currentDate = new Date();
    const currentMonth = currentDate.getMonth(); // 0-11
    const currentYear = currentDate.getFullYear();

    const filteredData = allRec.filter(rec => {
      const itemDate = new Date(rec.rec_dtNfPrev);
      return itemDate.getMonth() === currentMonth &&
            itemDate.getFullYear() === currentYear &&
            !rec.nf_id &&
            rec.rec_fat != 1 &&
            myProjectNames.includes(rec.recProjeto);
    });

    const produtosEmAndamento = (filteredData).sort((a, b) => {
      if (new Date(a.rec_dtNfPrev) < new Date(b.rec_dtNfPrev)) return -1;
      if (new Date(a.rec_dtNfPrev) > new Date(b.rec_dtNfPrev)) return 1;
      return 0;
    });

    this.setState({receitas: produtosEmAndamento})
  }

  render() {

    return (
      <Card>
        <CardBody style={{overflow: "auto", maxHeight: "400px"}}>
          <Row className="d-flex justify-content-between">
            <Col>
              <h4 className="card-title mb-4">Minhas Aprovações</h4>
            </Col>
          </Row>
            {this.state.receitas ?
              this.state.receitas.map(r => (
                <>
                  <div style={{
                    color: (new Date() >= new Date(`${r.rec_dtNfPrev}T00:00:00-03:00`).setDate(new Date(`${r.rec_dtNfPrev}T00:00:00-03:00`).getDate() - 4) && new Date().getDate() <= new Date(`${r.rec_dtNfPrev}T00:00:00-03:00`).getDate()) ? "#fcb92c" :
                    new Date() > new Date(`${r.rec_dtNfPrev}T00:00:00-03:00`) ? "red" : ""
                  }}>
                    <span style={{fontWeight: "bold"}}>Projeto: </span><span>{r.recProjeto}</span><br />
                    <span style={{fontWeight: "bold"}}>EP: </span><span>{r.rec_ep}</span><br />
                    <span style={{fontWeight: "bold"}}>Limite Aprov: </span><span>{moment(r.rec_dtNfPrev).format("DD/MM/YYYY")}</span>
                  </div>
                  <br />
                  <br />
                </>
              )) :
              <div className='d-flex justify-content-center align-items-center'>
                <Spinner />
              </div>
              }
        </CardBody>
      </Card>
    )
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  humanResources: state.humanResources,
})
const mapDispatchToProps = dispatch => bindActionCreators({
  getProjects,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(EPApprovement)
